import { render, staticRenderFns } from "./Kit.vue?vue&type=template&id=48107360"
import script from "./Kit.vue?vue&type=script&lang=ts"
export * from "./Kit.vue?vue&type=script&lang=ts"
import style0 from "./Kit.vue?vue&type=style&index=0&id=48107360&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports